import type {Resource} from "crqlar-react-common/dist/models/resource/resource.model";
import {useAllRootResourcesForSector} from "crqlar-react-common/dist/utils/hooks/resources/useAllRootResources";
import type {ReservationsSectorState} from "../../../store/reservations.reducer";
import {usePersistentEntitySelection} from "./usePersistentEntitySelection";

export type ReservationResourceViewKey = Extract<
    ReservationsSectorState["activeTab"],
    "action-center" | "daily" | "calendar" | "list"
>;

interface UseReservationResourceSelectionInput {
    sectorId: string;
    viewKey: ReservationResourceViewKey;
}

export interface ReservationResourceSelection {
    sectorId: string;
    viewKey: ReservationResourceViewKey;
    resources: Resource[];
    selectedResources: Resource[];
    selectedIds: string[];
    selectedIdSet: ReadonlySet<string>;
    allSelected: boolean;
    setSelectedIds: (ids: readonly string[]) => void;
    toggleAll: () => void;
    toggleGroup: (ids: readonly string[]) => void;
    toggleResource: (id: string) => void;
}

export function useReservationResourceSelection({
    sectorId,
    viewKey,
}: UseReservationResourceSelectionInput): ReservationResourceSelection {
    const resources = useAllRootResourcesForSector(sectorId);
    const storageKey = `selectedResources-${sectorId}-${viewKey}`;
    const {
        selectedEntities: selectedResources,
        selectedIds,
        selectedIdSet,
        allSelected,
        setSelectedIds,
        toggleAll,
        toggleGroup,
        toggleEntity: toggleResource,
    } = usePersistentEntitySelection({entities: resources, storageKey});

    return {
        sectorId,
        viewKey,
        resources,
        selectedResources,
        selectedIds,
        selectedIdSet,
        allSelected,
        setSelectedIds,
        toggleAll,
        toggleGroup,
        toggleResource,
    };
}
